export default "/assets/images/George.a67495fbbc84b94f.webm";